import { HttpClient } from "@angular/common/http";
import { Component, inject, signal } from "@angular/core";
import { head } from "lodash";
import { DataService } from "src/app/data.service";

@Component({
  selector: "app-deletions",
  templateUrl: "./deletions.component.html",
  styleUrl: "./deletions.component.css",
})
export class DeletionsComponent {
  navButtons = [];
  dataLoading = signal(false);
  _dataService = inject(DataService);
  http = inject(HttpClient);
  tableData = [];

  columnDefs = [
    { headerName: "", field: "id", flex: 1, maxWidth: 80, hide: true },
    {
      headerName: "tId",
      field: "id",
      flex: 1,
    },
    {
      headerName: "Type",
      field: "type",
      flex: 2,
      cellRenderer: (params) => {
        return this._dataService.getTransactionType(params.value);
      },
    },
    {
      headerName: "Tərəf Müqabil",
      field: "customerId",
      flex: 2,
      cellRenderer: (params) => {
        let c = this._dataService
          .customers()
          .find((c) => c.id === params.value);
        return c?.name ?? null;
      },
    },
    {
      headerName: "Məbləğ",
      field: "sum",
      flex: 2,
      cellRenderer: (params) => {
        return this._dataService.getTransactionType(params.value);
      },
    },
    {
      headerName: "İstifadəçi",
      field: "userId",
      flex: 2,
      cellRenderer: (params) => {
        let c = this._dataService.users().find((c) => c.id === params.value);
        return c?.fullname ?? null;
      },
    },
    {
      headerName: "Tarix",
      field: "date",
      flex: 2,
      minWidth: 120,
      sortable: true,
      cellRenderer: (params) => {
        return params.value.split("-").reverse().join("-");
      },
    },
  ];

  ngOnInit() {
    this.dataLoading.set(true);
    this.http
      .get<any>(
        `https://tekoplast.az/jjapi/api.php/records/transactions?filter=status,eq,1`
      )
      .subscribe((r) => {
        this.tableData = r.records;
        console.log(this.tableData);
        this.dataLoading.set(false);
      });
  }

  openTransaction(transaction) {
    this._dataService.transactionDialog({
      id: transaction.id,
      type: transaction.type,
    });
  }
}
